import * as React from "react";
import { AutocompleteInput } from "react-admin";
import { ROLE_TYPES } from "../enums/Roles";

export const AutocompleteInputDefaultValue = ({
  permissions,
  optionText,
  validate,
  ...rest
}) => {
  const { choices } = rest;
  let defaultChoice = choices && choices.length === 1 ? choices[0] : "";
  return (
    <AutocompleteInput
      optionText={optionText}
      defaultValue={
        permissions === ROLE_TYPES.RESTAURANT ? defaultChoice.id : null
      }
      validate={validate}
      {...rest}
    />
  );
};
